// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion_Accordion__HQvGc","title":"Accordion_title__tD2pZ","content":"Accordion_content__5LU2x","Accordion__open":"Accordion_Accordion__open__4ATEf"};